module.exports = __webpack_public_path__ + "img/product-oil-slider.31bb0c86.jpg";